import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, Ref } from 'vue'
import { SearchParams } from '../interfaces'
import { CardStatus, cardStatusName, enumGetValues, MunicipalEntitiesService } from '@prodcard/core'
import { VMunicipalEntitiesSelect } from 'libs/apps-vue/src/components'

interface Props {
  defaultSearchParams?: SearchParams
  municipalEntitiesService: MunicipalEntitiesService
  monthItems: {
    value: number
    title: string
  }[]
  yearItems: number[]
  loading?: boolean
  readonlyMe?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBox',
  props: {
    defaultSearchParams: { default: () => ({
    search: '',
    municipalEntityId: undefined,
    cardStatus: undefined,
    month: undefined,
    year: undefined,
  }) },
    municipalEntitiesService: {},
    monthItems: {},
    yearItems: {},
    loading: { type: Boolean, default: false },
    readonlyMe: { type: Boolean, default: false }
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props;





const searchParams: Ref<SearchParams> = ref({
  search: props.defaultSearchParams.search,
  municipalEntityId: props.defaultSearchParams.municipalEntityId,
  cardStatus: props.defaultSearchParams.cardStatus,
  month: props.defaultSearchParams.month,
  year: props.defaultSearchParams.year,
})

const cardStatuses = enumGetValues(CardStatus).map(s => {
  return {
    title: cardStatusName(s as CardStatus),
    value: s,
  }
})

const update = (e: Event, reset?: boolean) => {
  if (reset) {
    Object.assign(searchParams.value, {
      search: '',
      municipalEntityId: props.readonlyMe ? searchParams.value.municipalEntityId : undefined,
      cardStatus: undefined,
      month: undefined,
      year: undefined,
    })
  }
  emit('update', searchParams.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    onKeyup: _withKeys(update, ["enter"]),
                    modelValue: searchParams.value.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.search) = $event)),
                    label: "ФИО, документ, адрес",
                    "prepend-inner-icon": "mdi-magnify",
                    density: "comfortable"
                  }, null, 8, ["onKeyup", "modelValue"])
                ]),
                _: 1
              }),
              (!_ctx.readonlyMe)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VMunicipalEntitiesSelect), {
                        modelValue: searchParams.value.municipalEntityId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.municipalEntityId) = $event)),
                        "municipal-entities-service": _ctx.municipalEntitiesService,
                        readonly: _ctx.readonlyMe,
                        density: "comfortable"
                      }, null, 8, ["modelValue", "municipal-entities-service", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: searchParams.value.cardStatus,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.cardStatus) = $event)),
                    items: _unref(cardStatuses),
                    label: "Статус карты",
                    density: "comfortable",
                    clearable: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: searchParams.value.month,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.month) = $event)),
                    items: _ctx.monthItems,
                    label: "Месяц",
                    density: "comfortable",
                    clearable: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: searchParams.value.year,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchParams.value.year) = $event)),
                    items: _ctx.yearItems,
                    label: "Год",
                    density: "comfortable",
                    clearable: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, { cols: "auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    icon: "mdi-magnify",
                    onClick: update,
                    loading: _ctx.loading
                  }, null, 8, ["loading"]),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    icon: "mdi-restore",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (update($event, true))),
                    disabled: _ctx.loading
                  }, null, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})